import { login, logout, signup, forgotPassword, studentLogin } from "./auth";

export { login, logout, signup, forgotPassword, studentLogin };
